export class NavigationItemConstants {
  public static readonly MyListingName: string = 'My Listings';
  public static readonly InProgressName: string = 'In Progress';
  public static readonly AwaitingPaymentName: string = 'Awaiting Payment';
  public static readonly ActionRequiredName: string = 'Action Required';
  public static readonly AccountName: string = 'Account';
}
